import { InjectionToken, Inject, ɵɵdefineInjectable, ɵɵinject, Injectable, Injector, NgZone, Component, PLATFORM_ID, Optional, SkipSelf, NgModule } from '@angular/core';
import { __decorate, __param, __metadata } from 'tslib';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import { AngularFireAuth, AngularFireAuthModule } from '@angular/fire/auth';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, of, ReplaySubject, empty, from } from 'rxjs';
import { filter, share, map, switchMap, tap, catchError, concatMap, first, throwIfEmpty, take, takeWhile } from 'rxjs/operators';
import { HttpResponse, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { v4 } from 'uuid';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'ngx-cookie-service';
import * as ɵngcc3 from '@angular/fire/auth';
import * as ɵngcc4 from '@angular/router';
const defaultAuthOptions = {
    strategies: [],
};
const AUTH_OPTIONS = new InjectionToken("Auth Options");
const AUTH_USER_OPTIONS = new InjectionToken("Auth User Options");
const AUTH_STRATEGIES = new InjectionToken("Auth Strategies");
const AUTH_TOKENS = new InjectionToken("Auth Tokens");
const AUTH_INTERCEPTOR_HEADER = new InjectionToken("Auth Simple Interceptor Header");
const AUTH_TOKEN_INTERCEPTOR_FILTER = new InjectionToken("Auth Token Interceptor Filter");
const AUTH_WINDOW = new InjectionToken("Auth Window");
const AUTH_DOCUMENT = new InjectionToken("Auth Document");

function isSpecificValue(val) {
    return val instanceof Date || val instanceof RegExp ? true : false;
}
function cloneSpecificValue(val) {
    if (val instanceof Date) {
        return new Date(val.getTime());
    }
    else if (val instanceof RegExp) {
        return new RegExp(val);
    }
    else {
        throw new Error("cloneSpecificValue: Unexpected situation");
    }
}
function deepCloneArray(arr) {
    const clone = [];
    arr.forEach(function (item, index) {
        if (typeof item === "object" && item !== null) {
            if (Array.isArray(item)) {
                clone[index] = deepCloneArray(item);
            }
            else if (isSpecificValue(item)) {
                clone[index] = cloneSpecificValue(item);
            }
            else {
                clone[index] = deepExtend({}, item);
            }
        }
        else {
            clone[index] = item;
        }
    });
    return clone;
}
const deepExtend = function (...objects) {
    if (arguments.length < 1 || typeof arguments[0] !== "object") {
        return false;
    }
    if (arguments.length < 2) {
        return arguments[0];
    }
    const target = arguments[0];
    const args = Array.prototype.slice.call(arguments, 1);
    let val, src;
    args.forEach(function (obj) {
        if (typeof obj !== "object" || Array.isArray(obj)) {
            return;
        }
        Object.keys(obj).forEach(function (key) {
            src = target[key];
            val = obj[key];
            if (val === target) {
                return;
            }
            else if (typeof val !== "object" || val === null) {
                target[key] = val;
                return;
            }
            else if (Array.isArray(val)) {
                target[key] = deepCloneArray(val);
                return;
            }
            else if (isSpecificValue(val)) {
                target[key] = cloneSpecificValue(val);
                return;
            }
            else if (typeof src !== "object" || src === null || Array.isArray(src)) {
                target[key] = deepExtend({}, val);
                return;
            }
            else {
                target[key] = deepExtend(src, val);
                return;
            }
        });
    });
    return target;
};
function getDeepFromObject(object = {}, name, defaultValue) {
    const keys = name.split(".");
    let level = deepExtend({}, object || {});
    keys.forEach(k => {
        if (level && typeof level[k] !== "undefined") {
            level = level[k];
        }
        else {
            level = undefined;
        }
    });
    return typeof level === "undefined" ? defaultValue : level;
}
function urlBase64Decode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch (output.length % 4) {
        case 0: {
            break;
        }
        case 2: {
            output += "==";
            break;
        }
        case 3: {
            output += "=";
            break;
        }
        default: {
            throw new Error("Illegal base64url string!");
        }
    }
    return b64DecodeUnicode(output);
}
function b64decode(str) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let output = "";
    str = String(str).replace(/=+$/, "");
    if (str.length % 4 === 1) {
        throw new Error(`'atob' failed: The string to be decoded is not correctly encoded.`);
    }
    for (let bc = 0, bs, buffer, idx = 0; (buffer = str.charAt(idx++)); ~buffer &&
        ((bs = bc % 4 ? bs * 64 + buffer : buffer),
            bc++ % 4)
        ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
        : 0) {
        buffer = chars.indexOf(buffer);
    }
    return output;
}
function b64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map
        .call(b64decode(str), (c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
}

const prepareOAuth2Token = data => {
    if (typeof data === "string") {
        try {
            return JSON.parse(data);
        }
        catch (e) { }
    }
    return data;
};
const ɵ0 = prepareOAuth2Token;
function decodeJwtPayload(payload) {
    if (payload.length === 0) {
        throw new AuthEmptyTokenError("Cannot extract from an empty payload.");
    }
    const parts = payload.split(".");
    if (parts.length !== 3) {
        throw new AuthIllegalJWTTokenError(`The payload ${payload} is not valid JWT payload and must consist of three parts.`);
    }
    let decoded;
    try {
        decoded = urlBase64Decode(parts[1]);
    }
    catch (e) {
        throw new AuthIllegalJWTTokenError(`The payload ${payload} is not valid JWT payload and cannot be parsed.`);
    }
    if (!decoded) {
        throw new AuthIllegalJWTTokenError(`The payload ${payload} is not valid JWT payload and cannot be decoded.`);
    }
    return JSON.parse(decoded);
}
class AuthTokenNotFoundError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class AuthIllegalTokenError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class AuthEmptyTokenError extends AuthIllegalTokenError {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class AuthIllegalJWTTokenError extends AuthIllegalTokenError {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class AuthToken {
    constructor() {
        this.payload = null;
    }
    getName() {
        return this.constructor.NAME;
    }
    getPayload() {
        return this.payload;
    }
}
function AuthCreateToken(tokenClass, token, ownerStrategyName, createdAt) {
    return new tokenClass(token, ownerStrategyName, createdAt);
}
class AuthSimpleToken extends AuthToken {
    constructor(token, ownerStrategyName, createdAt) {
        super();
        this.token = token;
        this.ownerStrategyName = ownerStrategyName;
        this.createdAt = createdAt;
        try {
            this.parsePayload();
        }
        catch (err) {
            if (!(err instanceof AuthTokenNotFoundError)) {
                throw err;
            }
        }
        this.createdAt = this.prepareCreatedAt(createdAt);
    }
    parsePayload() {
        this.payload = null;
    }
    prepareCreatedAt(date) {
        return date ? date : new Date();
    }
    getCreatedAt() {
        return this.createdAt;
    }
    getValue() {
        return this.token;
    }
    getOwnerStrategyName() {
        return this.ownerStrategyName;
    }
    isValid() {
        return !!this.getValue();
    }
    toString() {
        return !!this.token ? this.token : "";
    }
}
AuthSimpleToken.NAME = "auth:simple:token";
class AuthJWTToken extends AuthSimpleToken {
    prepareCreatedAt(date) {
        const decoded = this.getPayload();
        return decoded && decoded.iat ? new Date(Number(decoded.iat) * 1000) : super.prepareCreatedAt(date);
    }
    parsePayload() {
        if (!this.token) {
            throw new AuthTokenNotFoundError("Token not found.");
        }
        this.payload = decodeJwtPayload(this.token);
    }
    getTokenExpDate() {
        const decoded = this.getPayload();
        if (decoded && !decoded.hasOwnProperty("exp")) {
            return null;
        }
        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    }
    isValid() {
        return super.isValid() && (!this.getTokenExpDate() || new Date() < this.getTokenExpDate());
    }
}
AuthJWTToken.NAME = "auth:jwt:token";
class AuthOAuth2Token extends AuthSimpleToken {
    constructor(data = {}, ownerStrategyName, createdAt) {
        super(prepareOAuth2Token(data), ownerStrategyName, createdAt);
    }
    getValue() {
        return this.token.access_token;
    }
    getRefreshToken() {
        return this.token.refresh_token;
    }
    setRefreshToken(refreshToken) {
        this.token.refresh_token = refreshToken;
    }
    parsePayload() {
        if (!this.token) {
            throw new AuthTokenNotFoundError("Token not found.");
        }
        else {
            if (!Object.keys(this.token).length) {
                throw new AuthEmptyTokenError("Cannot extract payload from an empty token.");
            }
        }
        this.payload = this.token;
    }
    getType() {
        return this.token.token_type;
    }
    isValid() {
        return super.isValid() && (!this.getTokenExpDate() || new Date() < this.getTokenExpDate());
    }
    getTokenExpDate() {
        if (!this.token.hasOwnProperty("expires_in")) {
            return null;
        }
        return new Date(this.createdAt.getTime() + Number(this.token.expires_in) * 1000);
    }
    toString() {
        return JSON.stringify(this.token);
    }
}
AuthOAuth2Token.NAME = "auth:oauth2:token";
class AuthOAuth2JWTToken extends AuthOAuth2Token {
    parsePayload() {
        super.parsePayload();
        this.parseAccessTokenPayload();
    }
    parseAccessTokenPayload() {
        const accessToken = this.getValue();
        if (!accessToken) {
            throw new AuthTokenNotFoundError("access_token key not found.");
        }
        this.accessTokenPayload = decodeJwtPayload(accessToken);
    }
    getAccessTokenPayload() {
        return this.accessTokenPayload;
    }
    prepareCreatedAt(date) {
        const payload = this.accessTokenPayload;
        return payload && payload.iat ? new Date(Number(payload.iat) * 1000) : super.prepareCreatedAt(date);
    }
    isValid() {
        return this.accessTokenPayload && super.isValid();
    }
    getTokenExpDate() {
        if (this.accessTokenPayload && this.accessTokenPayload.hasOwnProperty("exp")) {
            const date = new Date(0);
            date.setUTCSeconds(this.accessTokenPayload.exp);
            return date;
        }
        else {
            return super.getTokenExpDate();
        }
    }
}
AuthOAuth2JWTToken.NAME = "auth:oauth2:jwt:token";

const AUTH_FALLBACK_TOKEN = new InjectionToken("Auth Options");
let AuthTokenParceler = class AuthTokenParceler {
    constructor(fallbackClass, tokenClasses) {
        this.fallbackClass = fallbackClass;
        this.tokenClasses = tokenClasses;
    }
    wrap(token) {
        return JSON.stringify({
            name: token.getName(),
            ownerStrategyName: token.getOwnerStrategyName(),
            createdAt: token.getCreatedAt().getTime(),
            value: token.toString(),
        });
    }
    unwrap(value) {
        let tokenClass = this.fallbackClass;
        let tokenValue = "";
        let tokenOwnerStrategyName = "";
        let tokenCreatedAt = new Date();
        const tokenPack = this.parseTokenPack(value);
        if (tokenPack) {
            tokenClass = this.getClassByName(tokenPack.name) || this.fallbackClass;
            tokenValue = tokenPack.value;
            tokenOwnerStrategyName = tokenPack.ownerStrategyName;
            tokenCreatedAt = new Date(Number(tokenPack.createdAt));
        }
        return AuthCreateToken(tokenClass, tokenValue, tokenOwnerStrategyName, tokenCreatedAt);
    }
    getClassByName(name) {
        return this.tokenClasses.find((tokenClass) => tokenClass.NAME === name);
    }
    parseTokenPack(value) {
        try {
            return JSON.parse(value);
        }
        catch (e) { }
        return null;
    }
};
AuthTokenParceler.ɵfac = function AuthTokenParceler_Factory(t) { return new (t || AuthTokenParceler)(ɵngcc0.ɵɵinject(AUTH_FALLBACK_TOKEN), ɵngcc0.ɵɵinject(AUTH_TOKENS)); };
AuthTokenParceler.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_FALLBACK_TOKEN,] }] },
    { type: Array, decorators: [{ type: Inject, args: [AUTH_TOKENS,] }] }
];
AuthTokenParceler.ɵprov = ɵɵdefineInjectable({ factory: function AuthTokenParceler_Factory() { return new AuthTokenParceler(ɵɵinject(AUTH_FALLBACK_TOKEN), ɵɵinject(AUTH_TOKENS)); }, token: AuthTokenParceler, providedIn: "root" });
AuthTokenParceler = __decorate([ __param(0, Inject(AUTH_FALLBACK_TOKEN)),
    __param(1, Inject(AUTH_TOKENS)),
    __metadata("design:paramtypes", [Object, Array])
], AuthTokenParceler);

class TokenStorage {
}
let TokenLocalStorage = class TokenLocalStorage extends TokenStorage {
    constructor(parceler) {
        super();
        this.parceler = parceler;
        this.key = "auth_app_token";
    }
    get() {
        const raw = localStorage.getItem(this.key);
        return this.parceler.unwrap(raw);
    }
    set(token) {
        const raw = this.parceler.wrap(token);
        localStorage.setItem(this.key, raw);
    }
    clear() {
        localStorage.removeItem(this.key);
    }
};
TokenLocalStorage.ɵfac = function TokenLocalStorage_Factory(t) { return new (t || TokenLocalStorage)(ɵngcc0.ɵɵinject(AuthTokenParceler)); };
TokenLocalStorage.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TokenLocalStorage, factory: TokenLocalStorage.ɵfac });
TokenLocalStorage.ctorParameters = () => [
    { type: AuthTokenParceler }
];
TokenLocalStorage = __decorate([ __metadata("design:paramtypes", [AuthTokenParceler])
], TokenLocalStorage);

let TokenService = class TokenService {
    constructor(tokenStorage) {
        this.tokenStorage = tokenStorage;
        this.token$ = new BehaviorSubject(null);
        this.publishStoredToken();
    }
    tokenChange() {
        return this.token$.pipe(filter(value => !!value), share());
    }
    set(token) {
        this.tokenStorage.set(token);
        this.publishStoredToken();
        return of(null);
    }
    get() {
        const token = this.tokenStorage.get();
        return of(token);
    }
    clear() {
        this.tokenStorage.clear();
        this.publishStoredToken();
        return of(null);
    }
    publishStoredToken() {
        this.token$.next(this.tokenStorage.get());
    }
};
TokenService.ɵfac = function TokenService_Factory(t) { return new (t || TokenService)(ɵngcc0.ɵɵinject(TokenStorage)); };
TokenService.ctorParameters = () => [
    { type: TokenStorage }
];
TokenService.ɵprov = ɵɵdefineInjectable({ factory: function TokenService_Factory() { return new TokenService(ɵɵinject(TokenStorage)); }, token: TokenService, providedIn: "root" });
TokenService = __decorate([ __metadata("design:paramtypes", [TokenStorage])
], TokenService);

var AuthService_1;
let AuthService = AuthService_1 = class AuthService {
    constructor(tokenService, strategies) {
        this.tokenService = tokenService;
        this.strategies = strategies;
    }
    getAuthContext() {
        return AuthService_1.authContext$;
    }
    setAuthContext(user) {
        AuthService_1.authContext$.next(user);
    }
    getToken() {
        return this.tokenService.get();
    }
    getStrategyToken(strategyName) {
        return this.getStrategy(strategyName)
            .getToken();
    }
    isAuthenticated() {
        return this.getToken().pipe(map((token) => token.isValid()));
    }
    isAuthenticatedOrRefresh() {
        return this.getToken().pipe(switchMap(token => {
            if (token.getValue() && token.isValid()) {
                return this.refreshToken(token.getOwnerStrategyName(), token).pipe(switchMap(res => {
                    if (res.isSuccess()) {
                        return this.isAuthenticated();
                    }
                    else {
                        return of(false);
                    }
                }));
            }
            else {
                return of(token.isValid());
            }
        }));
    }
    getCurrentUser(strategyName) {
        return this.getStrategy(strategyName).currentUser();
    }
    onTokenChange() {
        return this.tokenService.tokenChange();
    }
    onAuthenticationChange() {
        return this.onTokenChange().pipe(map((token) => token.isValid()));
    }
    authenticate(strategyName, data) {
        return this.getStrategy(strategyName)
            .authenticate(data)
            .pipe(switchMap((result) => this.processResultToken(result)));
    }
    register(strategyName, data) {
        return this.getStrategy(strategyName)
            .register(data)
            .pipe(switchMap((result) => this.processResultToken(result)));
    }
    logout(strategyName) {
        return this.getStrategy(strategyName)
            .logout()
            .pipe(switchMap((result) => {
            if (result.isSuccess()) {
                this.tokenService.clear().pipe(map(() => result));
            }
            return of(result);
        }));
    }
    requestPassword(strategyName, data) {
        return this.getStrategy(strategyName).requestPassword(data);
    }
    resetPassword(strategyName, data) {
        return this.getStrategy(strategyName).resetPassword(data);
    }
    refreshToken(strategyName, data) {
        return this.getStrategy(strategyName)
            .refreshToken(data)
            .pipe(switchMap((result) => this.processResultToken(result)));
    }
    getStrategy(strategyName) {
        const found = this.strategies.find((strategy) => strategy.getName() === strategyName);
        if (!found) {
            throw new TypeError(`There is no Auth Strategy registered under '${strategyName}' name`);
        }
        return found;
    }
    processResultToken(result) {
        if (result.isSuccess() && result.getToken()) {
            return this.tokenService.set(result.getToken()).pipe(map((token) => result));
        }
        return of(result);
    }
};
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(TokenService), ɵngcc0.ɵɵinject(AUTH_STRATEGIES)); };
AuthService.authContext$ = new ReplaySubject(1);
AuthService.ctorParameters = () => [
    { type: TokenService },
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_STRATEGIES,] }] }
];
AuthService.ɵprov = ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(ɵɵinject(TokenService), ɵɵinject(AUTH_STRATEGIES)); }, token: AuthService, providedIn: "root" });
AuthService = AuthService_1 = __decorate([ __param(1, Inject(AUTH_STRATEGIES)),
    __metadata("design:paramtypes", [TokenService, Object])
], AuthService);

class AuthResult {
    constructor(success, response, redirect, errors, messages, token) {
        this.success = success;
        this.response = response;
        this.redirect = redirect;
        this.errors = [];
        this.messages = [];
        this.errors = this.errors.concat([errors]);
        if (errors instanceof Array) {
            this.errors = errors;
        }
        this.messages = this.messages.concat([messages]);
        if (messages instanceof Array) {
            this.messages = messages;
        }
        if (token instanceof AuthToken) {
            this.token = token;
        }
    }
    getResponse() {
        return this.response;
    }
    getToken() {
        return this.token;
    }
    getRedirect() {
        return this.redirect;
    }
    getErrors() {
        return this.errors.filter(val => !!val);
    }
    getMessages() {
        return this.messages.filter(val => !!val);
    }
    isSuccess() {
        return this.success;
    }
    isFailure() {
        return !this.success;
    }
}

let AuthJWTInterceptor = class AuthJWTInterceptor {
    constructor(injector, filter) {
        this.injector = injector;
        this.filter = filter;
    }
    intercept(req, next) {
        if (!this.filter(req)) {
            return this.authService.isAuthenticatedOrRefresh().pipe(switchMap(authenticated => {
                if (authenticated) {
                    return this.authService.getToken().pipe(switchMap((token) => {
                        const JWT = `Bearer ${token.getValue()}`;
                        req = req.clone({
                            setHeaders: {
                                Authorization: JWT,
                            },
                        });
                        return next.handle(req);
                    }));
                }
                else {
                    return next.handle(req);
                }
            }));
        }
        else {
            return next.handle(req);
        }
    }
    get authService() {
        return this.injector.get(AuthService);
    }
};
AuthJWTInterceptor.ɵfac = function AuthJWTInterceptor_Factory(t) { return new (t || AuthJWTInterceptor)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(AUTH_TOKEN_INTERCEPTOR_FILTER)); };
AuthJWTInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthJWTInterceptor, factory: AuthJWTInterceptor.ɵfac });
AuthJWTInterceptor.ctorParameters = () => [
    { type: Injector },
    { type: undefined, decorators: [{ type: Inject, args: [AUTH_TOKEN_INTERCEPTOR_FILTER,] }] }
];
AuthJWTInterceptor = __decorate([ __param(1, Inject(AUTH_TOKEN_INTERCEPTOR_FILTER)),
    __metadata("design:paramtypes", [Injector, Object])
], AuthJWTInterceptor);

let AuthSimpleInterceptor = class AuthSimpleInterceptor {
    constructor(injector, headerName = "Authorization") {
        this.injector = injector;
        this.headerName = headerName;
    }
    intercept(req, next) {
        return this.authService.getToken().pipe(switchMap((token) => {
            if (token && token.getValue()) {
                req = req.clone({
                    setHeaders: {
                        [this.headerName]: token.getValue(),
                    },
                });
            }
            return next.handle(req);
        }));
    }
    get authService() {
        return this.injector.get(AuthService);
    }
};
AuthSimpleInterceptor.ɵfac = function AuthSimpleInterceptor_Factory(t) { return new (t || AuthSimpleInterceptor)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(AUTH_INTERCEPTOR_HEADER)); };
AuthSimpleInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthSimpleInterceptor, factory: AuthSimpleInterceptor.ɵfac });
AuthSimpleInterceptor.ctorParameters = () => [
    { type: Injector },
    { type: String, decorators: [{ type: Inject, args: [AUTH_INTERCEPTOR_HEADER,] }] }
];
AuthSimpleInterceptor = __decorate([ __param(1, Inject(AUTH_INTERCEPTOR_HEADER)),
    __metadata("design:paramtypes", [Injector, String])
], AuthSimpleInterceptor);

class WindowRef {
    get nativeWindow() {
        throw new Error("Not implemented.");
    }
}
class BrowserWindowRef extends WindowRef {
    constructor() {
        super();
    }
    get nativeWindow() {
        return window;
    }
}

let AuthStrategy = class AuthStrategy {
    setOptions(options) {
        this.options = deepExtend({}, this.defaultOptions, options);
    }
    getOption(key) {
        return getDeepFromObject(this.options, key, null);
    }
    getName() {
        return this.getOption("name");
    }
    createToken(value, failWhenInvalidToken) {
        const tokenClass = this.getOption("token.class");
        const token = AuthCreateToken(tokenClass, value, this.getName());
        if (failWhenInvalidToken && !token.isValid()) {
            throw new AuthIllegalTokenError("Token is empty or invalid.");
        }
        return token;
    }
    createFailResponse(data) {
        return new HttpResponse({ body: {}, status: 401 });
    }
    createSuccessResponse(data) {
        return new HttpResponse({ body: {}, status: 200 });
    }
    getActionEndpoint(action) {
        const actionEndpoint = this.getOption(`${action}.endpoint`);
        const baseEndpoint = this.getOption("baseEndpoint");
        return `${baseEndpoint}${actionEndpoint}`;
    }
};
AuthStrategy.ɵfac = function AuthStrategy_Factory(t) { return new (t || AuthStrategy)(); };
AuthStrategy.ɵprov = ɵɵdefineInjectable({ factory: function AuthStrategy_Factory() { return new AuthStrategy(); }, token: AuthStrategy, providedIn: "root" });

class AuthStrategyOptions {
}

var SingleSignOnResponseType;
(function (SingleSignOnResponseType) {
    SingleSignOnResponseType["TOKEN"] = "token";
    SingleSignOnResponseType["COOKIE"] = "cookie";
})(SingleSignOnResponseType || (SingleSignOnResponseType = {}));
class SingleSignOnAuthStrategyOptions extends AuthStrategyOptions {
    constructor() {
        super(...arguments);
        this.baseEndpoint = "";
        this.redirect = {
            success: "/",
            failure: null,
        };
        this.defaultErrors = ["Something went wrong, please try again."];
        this.defaultMessages = ["You have been successfully authenticated."];
        this.token = {
            endpoint: "validate-token",
            requireValidToken: false,
            class: AuthSimpleToken,
        };
        this.bootstrap = true;
    }
}
const SingleSignOnStrategyOptions = new SingleSignOnAuthStrategyOptions();

var SingleSignOnAuthStrategy_1;
let SingleSignOnAuthStrategy = SingleSignOnAuthStrategy_1 = class SingleSignOnAuthStrategy extends AuthStrategy {
    constructor(tokenService, http, cookie, authFirebase, route, window) {
        super();
        this.tokenService = tokenService;
        this.http = http;
        this.cookie = cookie;
        this.authFirebase = authFirebase;
        this.route = route;
        this.window = window;
        this.defaultOptions = SingleSignOnStrategyOptions;
        this.redirectResults = {
            [SingleSignOnResponseType.TOKEN]: () => {
                return of(this.route.snapshot.queryParams).pipe(map((params) => !!(params && params.token)));
            },
            [SingleSignOnResponseType.COOKIE]: () => {
                return of(this.cookie.get("firebase_token")).pipe(map((token) => !!token));
            },
        };
        this.redirectResultHandlers = {
            [SingleSignOnResponseType.TOKEN]: () => {
                return of(this.route.snapshot.queryParams).pipe(tap((params) => {
                    if (!!(params && params.token)) {
                        const now = new Date();
                        now.setTime(now.getTime() + 1 * 3600 * 1000 * 24);
                        this.cookie.set("firebase_token", params.token, now, "/", "localhost");
                    }
                }), switchMap((params) => (params.token ? this.requestToken(params.token) : of(null))));
            },
            [SingleSignOnResponseType.COOKIE]: () => {
                return of(this.cookie.get("firebase_token")).pipe(switchMap((token) => (token ? this.requestToken(token) : of(null))));
            },
        };
        this.currentFirebaseUserSubject = new BehaviorSubject(null);
    }
    get responseType() {
        return this.getOption("authorize.responseType");
    }
    static setup(options) {
        return [SingleSignOnAuthStrategy_1, options];
    }
    init() {
        this.authFirebase.onAuthStateChanged(user => {
            this.currentFirebaseUserSubject.next(user);
        });
        if (!this.getOption("bootstrap")) {
            return;
        }
        const source = this.redirectResultHandlers[SingleSignOnResponseType.COOKIE].call(this);
        source
            .pipe(switchMap(result => {
            if (!result) {
                return empty();
            }
            return of(this.createToken(result, true));
        }), switchMap((result) => this.processResultToken(result)), catchError(result => {
            const errors = this.handleResponseError(result);
            this.cookie.delete("firebase_token");
            return this.tokenService.clear().pipe(switchMap(() => of(errors)));
        }))
            .subscribe(value => {
            console.group("Init check auth - next");
            console.log(value);
            console.groupEnd();
        }, error => {
            console.group("Init check auth - error");
            console.log(error);
            console.groupEnd();
        }, () => {
            console.group("Init check auth - complete");
            console.log("Complete");
            console.groupEnd();
        });
    }
    ngOnDestroy() {
        this.currentFirebaseUserSubject.unsubscribe();
    }
    authenticate(data) {
        return this.isRedirectResult().pipe(switchMap((result) => {
            if (!result) {
                this.authorizeRedirect();
                return empty();
            }
            return this.getAuthorizationResult();
        }), switchMap(result => {
            return of(new AuthResult(true, result, this.getOption("redirect.success"), [], this.getOption("defaultMessages"), this.createToken(result, true)));
        }), catchError(result => {
            const errors = this.handleResponseError(result);
            return of(new AuthResult(false, result, this.getOption("redirect.failure"), errors, []));
        }));
    }
    logout(data) {
        return from(this.authFirebase.signOut()).pipe(tap(() => this.cookie.delete("firebase_token")), map(() => new AuthResult(true)));
    }
    refreshToken(data) {
        throw new Error("`refreshToken` is not supported by `SingleSignOnAuthStrategy`, use `authenticate`.");
    }
    register(data) {
        throw new Error("`register` is not supported by `SingleSignOnAuthStrategy`, use `authenticate`.");
    }
    requestPassword(data) {
        throw new Error("`requestPassword` is not supported by `SingleSignOnAuthStrategy`, use `authenticate`.");
    }
    resetPassword(data) {
        throw new Error("`resetPassword` is not supported by `SingleSignOnAuthStrategy`, use `authenticate`.");
    }
    currentUser() {
        return this.currentFirebaseUserSubject;
    }
    getToken() {
        return this.tokenService.get().pipe(switchMap((token) => {
            if (token && token.isValid()) {
                return of(token);
            }
            else {
                const source = this.redirectResultHandlers[SingleSignOnResponseType.COOKIE].call(this);
                return source.pipe(switchMap((result) => {
                    if (!result) {
                        throw new Error("Token not found in cookie");
                    }
                    return of(this.createToken(result, true));
                }), switchMap((result) => this.processResultToken(result)));
            }
        }), switchMap((token) => of(token)));
    }
    getAuthorizationResult() {
        const strategies = Object.values(this.redirectResultHandlers);
        const source = from(strategies).pipe(concatMap(strategy => strategy()), first(), throwIfEmpty(() => new Error("Missing strategy result.")));
        return source;
    }
    authorizeRedirect() {
        this.window.location.href = this.getOption("authorize.redirectUri");
    }
    isRedirectResult() {
        const strategies = Object.values(this.redirectResults);
        const source = from(strategies).pipe(concatMap(strategy => strategy().pipe(catchError(() => empty()))), first(), throwIfEmpty(() => new Error("Missing strategy result.")));
        return source;
    }
    requestToken(token) {
        return this.createFirebaseAuthInstance(token).pipe(switchMap((UserCredential) => UserCredential.user.getIdToken()), map(token => token));
    }
    handleResponseError(res) {
        let errors = [];
        if (res instanceof HttpErrorResponse) {
            if (res.error.error_description) {
                errors.push(res.error.error_description);
            }
            else {
                errors = this.getOption("defaultErrors");
            }
        }
        else if (res instanceof AuthIllegalTokenError) {
            errors.push(res.message);
        }
        else if (res instanceof Error) {
            errors.push(res.message);
        }
        else {
            errors.push("Something went wrong.");
        }
        return errors;
    }
    createFirebaseAuthInstance(token) {
        const authPromise = this.authFirebase
            .setPersistence("none")
            .then(() => this.authFirebase.signInWithCustomToken(token));
        return from(authPromise);
    }
    validateToken(accessToken, uid) {
        const module = "token";
        const url = this.getActionEndpoint(module);
        return this.http
            .post(url, {
            correlationId: v4(),
            args: {
                token_id: accessToken,
            },
        })
            .pipe(filter((res) => !!res && Array.isArray(res.Collection)), map(res => res.Collection[0].uid === uid));
    }
    processResultToken(result) {
        return this.tokenService.set(result).pipe(map((token) => result));
    }
};
SingleSignOnAuthStrategy.ɵfac = function SingleSignOnAuthStrategy_Factory(t) { return new (t || SingleSignOnAuthStrategy)(ɵngcc0.ɵɵinject(TokenService), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.CookieService), ɵngcc0.ɵɵinject(ɵngcc3.AngularFireAuth), ɵngcc0.ɵɵinject(ɵngcc4.ActivatedRoute), ɵngcc0.ɵɵinject(AUTH_WINDOW)); };
SingleSignOnAuthStrategy.ctorParameters = () => [
    { type: TokenService },
    { type: HttpClient },
    { type: CookieService },
    { type: AngularFireAuth },
    { type: ActivatedRoute },
    { type: WindowRef, decorators: [{ type: Inject, args: [AUTH_WINDOW,] }] }
];
SingleSignOnAuthStrategy.ɵprov = ɵɵdefineInjectable({ factory: function SingleSignOnAuthStrategy_Factory() { return new SingleSignOnAuthStrategy(ɵɵinject(TokenService), ɵɵinject(HttpClient), ɵɵinject(CookieService), ɵɵinject(AngularFireAuth), ɵɵinject(ActivatedRoute), ɵɵinject(AUTH_WINDOW)); }, token: SingleSignOnAuthStrategy, providedIn: "root" });
SingleSignOnAuthStrategy = SingleSignOnAuthStrategy_1 = __decorate([ __param(5, Inject(AUTH_WINDOW)),
    __metadata("design:paramtypes", [TokenService,
        HttpClient,
        CookieService,
        AngularFireAuth,
        ActivatedRoute,
        WindowRef])
], SingleSignOnAuthStrategy);

let AuthGuard = class AuthGuard {
    constructor(router, auth) {
        this.router = router;
        this.auth = auth;
    }
    canActivate(next, state) {
        return this.auth.isAuthenticated().pipe(take(1), switchMap((authenticated) => {
            if (!authenticated) {
                this.router.navigate(["home"]);
            }
            return of(authenticated);
        }));
    }
};
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(ɵngcc4.Router), ɵngcc0.ɵɵinject(AuthService)); };
AuthGuard.ctorParameters = () => [
    { type: Router },
    { type: AuthService }
];
AuthGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(ɵɵinject(Router), ɵɵinject(AuthService)); }, token: AuthGuard, providedIn: "root" });
AuthGuard = __decorate([ __metadata("design:paramtypes", [Router, AuthService])
], AuthGuard);

let AuthResolver = class AuthResolver {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    resolve(route, state) {
        return "auth resolver";
    }
};
AuthResolver.ɵfac = function AuthResolver_Factory(t) { return new (t || AuthResolver)(ɵngcc0.ɵɵinject(AuthService), ɵngcc0.ɵɵinject(ɵngcc4.Router)); };
AuthResolver.ctorParameters = () => [
    { type: AuthService },
    { type: Router }
];
AuthResolver.ɵprov = ɵɵdefineInjectable({ factory: function AuthResolver_Factory() { return new AuthResolver(ɵɵinject(AuthService), ɵɵinject(Router)); }, token: AuthResolver, providedIn: "root" });
AuthResolver = __decorate([ __metadata("design:paramtypes", [AuthService, Router])
], AuthResolver);

let CallbackComponent = class CallbackComponent {
    constructor(authService, router, ngZone) {
        this.authService = authService;
        this.router = router;
        this.ngZone = ngZone;
        this.alive = true;
        this.authService
            .authenticate("sso")
            .pipe(takeWhile(() => this.alive))
            .subscribe((authResult) => {
            console.group("Callback Component");
            console.log(authResult);
            console.groupEnd();
            if (authResult.getRedirect()) {
                this.ngZone.run(() => this.router.navigateByUrl(authResult.getRedirect()));
            }
        });
    }
    ngOnDestroy() {
        this.alive = false;
    }
};
CallbackComponent.ɵfac = function CallbackComponent_Factory(t) { return new (t || CallbackComponent)(ɵngcc0.ɵɵdirectiveInject(AuthService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CallbackComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CallbackComponent, selectors: [["sso-callback"]], decls: 2, vars: 0, template: function CallbackComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtext(1, "Authenticating...");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
CallbackComponent.ctorParameters = () => [
    { type: AuthService },
    { type: Router },
    { type: NgZone }
];
CallbackComponent = __decorate([ __metadata("design:paramtypes", [AuthService, Router, NgZone])
], CallbackComponent);

var AuthModule_1;
function StrategiesFactory(options, injector) {
    const strategies = [];
    options.strategies.forEach(([strategyClass, strategyOptions]) => {
        const strategy = injector.get(strategyClass);
        strategy.setOptions(strategyOptions);
        strategy.init();
        strategies.push(strategy);
    });
    return strategies;
}
function TokensFactory() {
    return [AuthJWTToken];
}
function OptionsFactory(options) {
    return deepExtend(defaultAuthOptions, options);
}
function NoopInterceptorFilter(req) {
    return true;
}
function windowFactory(browserWindowRef, platformId) {
    if (isPlatformBrowser(platformId)) {
        return browserWindowRef.nativeWindow;
    }
    return new Object();
}
const browserWindowProvider = {
    provide: WindowRef,
    useClass: BrowserWindowRef
};
const windowProvider = {
    provide: AUTH_WINDOW,
    useFactory: windowFactory,
    deps: [WindowRef, PLATFORM_ID]
};
let AuthModule = AuthModule_1 = class AuthModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error("AuthModule is already loaded. Import it in the AppModule only");
        }
    }
    static forRoot(authOptions) {
        return {
            ngModule: AuthModule_1,
            providers: [
                { provide: AUTH_USER_OPTIONS, useValue: authOptions },
                {
                    provide: AUTH_OPTIONS,
                    useFactory: OptionsFactory,
                    deps: [AUTH_USER_OPTIONS]
                },
                {
                    provide: AUTH_STRATEGIES,
                    useFactory: StrategiesFactory,
                    deps: [AUTH_OPTIONS, Injector]
                },
                {
                    provide: AUTH_TOKENS,
                    useFactory: TokensFactory
                },
                { provide: AUTH_FALLBACK_TOKEN, useValue: AuthSimpleToken },
                { provide: AUTH_INTERCEPTOR_HEADER, useValue: "Authorization" },
                {
                    provide: AUTH_TOKEN_INTERCEPTOR_FILTER,
                    useValue: NoopInterceptorFilter
                },
                { provide: TokenStorage, useClass: TokenLocalStorage },
                browserWindowProvider,
                windowProvider,
                { provide: AUTH_DOCUMENT, useExisting: DOCUMENT },
                AuthTokenParceler,
                AuthService,
                AuthGuard,
                AuthResolver,
                TokenService,
                CookieService,
                SingleSignOnAuthStrategy
            ]
        };
    }
};
AuthModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AuthModule });
AuthModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AuthModule_Factory(t) { return new (t || AuthModule)(ɵngcc0.ɵɵinject(AuthModule, 12)); }, imports: [[CommonModule, AngularFireAuthModule]] });
AuthModule.ctorParameters = () => [
    { type: AuthModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
AuthModule = AuthModule_1 = __decorate([ __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [AuthModule])
], AuthModule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthTokenParceler, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_FALLBACK_TOKEN]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [AUTH_TOKENS]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TokenLocalStorage, [{
        type: Injectable
    }], function () { return [{ type: AuthTokenParceler }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TokenService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: TokenStorage }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: TokenService }, { type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_STRATEGIES]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthJWTInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: undefined, decorators: [{
                type: Inject,
                args: [AUTH_TOKEN_INTERCEPTOR_FILTER]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthSimpleInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: String, decorators: [{
                type: Inject,
                args: [AUTH_INTERCEPTOR_HEADER]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthStrategy, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SingleSignOnAuthStrategy, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: TokenService }, { type: ɵngcc1.HttpClient }, { type: ɵngcc2.CookieService }, { type: ɵngcc3.AngularFireAuth }, { type: ɵngcc4.ActivatedRoute }, { type: WindowRef, decorators: [{
                type: Inject,
                args: [AUTH_WINDOW]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ɵngcc4.Router }, { type: AuthService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthResolver, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: AuthService }, { type: ɵngcc4.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CallbackComponent, [{
        type: Component,
        args: [{
                selector: "sso-callback",
                template: `
        <div>Authenticating...</div>
    `
            }]
    }], function () { return [{ type: AuthService }, { type: ɵngcc4.Router }, { type: ɵngcc0.NgZone }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuthModule, { declarations: function () { return [CallbackComponent]; }, imports: function () { return [CommonModule, AngularFireAuthModule]; }, exports: function () { return [CallbackComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, AngularFireAuthModule],
                declarations: [CallbackComponent],
                exports: [CallbackComponent]
            }]
    }], function () { return [{ type: AuthModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

export { AUTH_DOCUMENT, AUTH_FALLBACK_TOKEN, AUTH_INTERCEPTOR_HEADER, AUTH_OPTIONS, AUTH_STRATEGIES, AUTH_TOKENS, AUTH_TOKEN_INTERCEPTOR_FILTER, AUTH_USER_OPTIONS, AUTH_WINDOW, AuthCreateToken, AuthEmptyTokenError, AuthGuard, AuthIllegalJWTTokenError, AuthIllegalTokenError, AuthJWTInterceptor, AuthJWTToken, AuthModule, AuthOAuth2JWTToken, AuthOAuth2Token, AuthResolver, AuthResult, AuthService, AuthSimpleInterceptor, AuthSimpleToken, AuthStrategy, AuthStrategyOptions, AuthToken, AuthTokenNotFoundError, AuthTokenParceler, BrowserWindowRef, CallbackComponent, NoopInterceptorFilter, OptionsFactory, SingleSignOnAuthStrategy, SingleSignOnAuthStrategyOptions, SingleSignOnResponseType, SingleSignOnStrategyOptions, StrategiesFactory, TokenLocalStorage, TokenService, TokenStorage, TokensFactory, WindowRef, decodeJwtPayload, defaultAuthOptions, windowFactory, ɵ0 };

//# sourceMappingURL=edpc-edp-auth.js.map